import {IconProps} from './types';

function ChevronFilled({fill = 'black'}: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M6.43712 7.48305L9.2658 4.78787C9.31299 4.74287 9.3757 4.71777 9.44091 4.71777C9.50612 4.71777 9.56882 4.74287 9.61602 4.78787L9.61906 4.79091C9.64202 4.81272 9.66031 4.83898 9.6728 4.86808C9.68529 4.89718 9.69174 4.92852 9.69174 4.96019C9.69174 4.99185 9.68529 5.02319 9.6728 5.05229C9.66031 5.08139 9.64202 5.10765 9.61906 5.12946L6.95535 7.6673L9.61906 10.2041C9.64202 10.2259 9.66031 10.2522 9.6728 10.2813C9.68529 10.3104 9.69174 10.3417 9.69174 10.3734C9.69174 10.4051 9.68529 10.4364 9.6728 10.4655C9.66031 10.4946 9.64202 10.5209 9.61906 10.5427L9.61602 10.5457C9.56882 10.5907 9.50612 10.6158 9.44091 10.6158C9.3757 10.6158 9.31299 10.5907 9.2658 10.5457L6.43712 7.85053C6.41225 7.82683 6.39244 7.79832 6.37891 7.76674C6.36538 7.73515 6.3584 7.70115 6.3584 7.66679C6.3584 7.63243 6.36538 7.59843 6.37891 7.56684C6.39244 7.53526 6.41225 7.50675 6.43712 7.48305Z"
                fill={fill}
                stroke={fill}
            />
        </svg>
    );
}

export default ChevronFilled;
